import { useDispatch, useSelector } from 'react-redux';
import styles from './GamesBlock.module.scss';
import {
  BaseText,
  EBaseTextPosition,
  EBaseTextSize,
  EBaseTextWeight,
} from '@spinwise/react-component-library/BaseText';
import { EBrandTextColor } from 'Libraries/typography.library';
import { IApplicationState, IGame, listGames } from '@spinwise/spinwise-core';
import { ButtonLibrary } from 'Libraries/buttons.library';
import { useEffect } from 'react';
import CarouselAuto from '../../shared/CarouselAuto/CarouselAuto';
import { POSITIONS, EOverlayContentWidth } from 'Components/shared/Overlay/elements/OverlayFixedBg/types';
import { t } from 'i18next';
import { basicChannel } from 'src/channels/basic.channel';
import GameThumbnailManager from 'Components/shared/GameThumbnailManager/GameThumbnailManager';
import { EComponentVisibility } from '@spinwise/react-component-library/Global';
import { ButtonTextOnly } from '@spinwise/react-component-library/ButtonTextOnly';
import {
  EBaseButtonSize,
  EBaseButtonTypeAttribute,
  EButtonBorderRadiusStrength,
  EButtonTextAlign,
} from '@spinwise/react-component-library/ButtonAbstract';
import { EBasicOverlays } from 'Components/shared/Overlay/elements/BasicOverlayManager/types';

const GamesBlock = ({ title, games_category }) => {
  const gamesByCategory = useSelector(
    (state: IApplicationState) => state.gamesReducer.gamesByCategory?.[games_category],
  );
  const dispatch = useDispatch();
  const { integrationKeys } = useSelector((state: IApplicationState) => state.globalReducer);
  /* Get games by category id from strapi */

  useEffect(() => {
    const payload = {
      category: [games_category],
      gamesPerPage: null,
      limit: 0,
      showBonusAllowed: false,
    };
    listGames(payload)(dispatch);
  }, []);

  const getIntegration = item => {
    let integrationKey = integrationKeys.keys?.[item.urlKey];

    return integrationKey ?? false;
  };

  const handleClick = () => {
    basicChannel.send({
      action: 'display',
      data: {
        content: {
          type: EBasicOverlays.TournamentAllGames,
          overlayTitle: t('tournament.all.games.overlay.title'),
          gamesCategoryId: games_category,
        },
        position: POSITIONS.CENTER,
        contentWidth: EOverlayContentWidth.SMALL,
      },
    });
  };
  return (
    <>
      <div className={styles.games_container}>
        <div className={styles.games_container__title}>
          <div className={`${EComponentVisibility.MobileOnly}`}>
            <BaseText
              value={title}
              size={EBaseTextSize.Title4}
              color={EBrandTextColor.PurpleDark}
              weight={EBaseTextWeight.W600}
              alignment={EBaseTextPosition.Left}
            />
          </div>
          <div className={`${EComponentVisibility.TableteDesktop}`}>
            <BaseText
              value={title}
              size={EBaseTextSize.Title3}
              color={EBrandTextColor.PurpleDark}
              weight={EBaseTextWeight.W600}
              alignment={EBaseTextPosition.Center}
            />
          </div>
        </div>
        {gamesByCategory && gamesByCategory?.length !== 0 && (
          <>
            {gamesByCategory.length <= 8 && (
              /*TODO add gamesBlock types to strapi */
              <div className={gamesByCategory.length > 1 ? styles.gamesWrapperContainer : ''}>
                <div className={gamesByCategory.length > 1 ? styles.gamesWrapper : styles.gamesWrapperOneItem}>
                  {gamesByCategory.map((item: IGame, i: number) => {
                    let integrationKey = getIntegration(item);
                    return (
                      <GameThumbnailManager
                        key={item?.eid}
                        game={item}
                        integrationKeys={integrationKey}
                        size={160}
                      ></GameThumbnailManager>
                    );
                  })}
                </div>
              </div>
            )}
            {gamesByCategory.length > 8 && (
              <>
                <div className={`${EComponentVisibility.DesktopOnly}`}>
                  <div className={styles.games_container__slider}>
                    <CarouselAuto
                      gameList={[...gamesByCategory]}
                      imgWidthDesktop={144}
                      imgWidthMobile={144}
                      sliderHeight={'324px'}
                      sliderWidth={'100%'}
                      sliderOverflowX={''}
                      gridGap={'1rem'}
                      gamesListLength={gamesByCategory.length}
                    ></CarouselAuto>
                  </div>
                </div>
                <div className={`${EComponentVisibility.MobileTablet}`}>
                  <div className={styles.games_container__slider}>
                    <CarouselAuto
                      gameList={[...gamesByCategory]}
                      imgWidthDesktop={152}
                      imgWidthMobile={152}
                      sliderHeight={'auto'}
                      sliderWidth={'100%'}
                      sliderOverflowX={'scroll'}
                      gridGap={'0.5rem'}
                      gamesListLength={gamesByCategory.length}
                    ></CarouselAuto>
                  </div>
                </div>
                <div className={`${styles.games_container__button} d-fl jc-c`}>
                  <ButtonTextOnly
                    label={t('tournament.show.all.games.btn')}
                    size={EBaseButtonSize.Large}
                    type={ButtonLibrary.Bonuses}
                    borderRadius={EButtonBorderRadiusStrength.Eight}
                    typeAttribute={EBaseButtonTypeAttribute.Submit}
                    fullWidth={false}
                    alignText={EButtonTextAlign.Center}
                    onClick={() => handleClick()}
                  />
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default GamesBlock;
